import store from '@/store/store'
import mergeWith from 'ramda/src/mergeWith'
import concat from 'ramda/src/concat'
import variablesService from '@/services/amio/variables.service'
import toaster from '@/utils/toaster'
import { ITEM_IDS } from '@/utils/editor.constants'
import botModule from '@/store/modules/bot.module'

class VariablesModule {

  variables = {
    get: () => store.state.settings.variables.list,
    set: (variables) => store.commit('VARIABLES_SET', variables)
  };

  editedId = {
    get: () => store.state.settings.variables.editedId,
    set: (id) => store.commit('VARIABLE_EDITED_ID_SET', id)
  };

  variablesLoading = {
    get: () => store.state.settings.variables.loading,
    set: (isLoading) => store.commit('VARIABLES_LOADING_SET', isLoading)
  };

  variableError = {
    get: (variableId, colName) => store.state.settings.variables.errors[variableId]?.[colName],
    set(variableId, colName, errorDescription) {
      store.commit('VARIABLES_ERRORS_SET', { variableId, colName, errorDescription })
    }
  }

  isVariableBeingAdded = () => this.variables.get().some(variable => variable.id === ITEM_IDS.NEW)

  getVariablesMergedWithBotScope() {
    const mergedVariablesMap = {}
    for (const variable of this.variables.get()) {
      if (variable.scope === 'bot' && variable.scope_value !== botModule.getBotId()) continue
      if (variable.scope === 'global' && mergedVariablesMap[variable.name]) continue

      mergedVariablesMap[variable.name] = variable
    }

    return Object.values(mergedVariablesMap)
  }

  setVariable(index, variable) {
    store.commit('VARIABLE_UPDATE', { index, variable })
  }

  setVariableRefsCreates(creates) {
    store.commit('VARIABLES_REFS_CREATES_SET', creates)
  }

  setVariableRefsDeletes(deletes) {
    store.commit('VARIABLES_REFS_DELETES_SET', deletes)
  }

  resetVariableRefs() {
    this.setVariableRefsCreates([])
    this.setVariableRefsDeletes([])
  }

  variableRefs = () => store.state.settings.variables.refs

  restoreVariableRefs(archivedVariableRefs) {
    const variableRefs = mergeWith(concat, archivedVariableRefs, this.variableRefs())
    this.setVariableRefsDeletes(variableRefs.deletes)
    this.setVariableRefsCreates(variableRefs.creates)
  }

  async fetchVariables() {
    try {
      this.variablesLoading.set(true)
      this.variables.set(await variablesService.list())
    } catch (err) {
      toaster.error(err.message)
    } finally {
      this.variablesLoading.set(false)
    }
  }
}

export default new VariablesModule()
